export const MessageSentModal: string = 'MessageSentModal';
